export enum Environments {
  local = "local",
  localcms = "localcms",
  stagingcms = "stagingcms",
  prodcms = "productioncms",
  develop = "develop",
  staging = "staging",
  rc = "rc",
  production = "production",
}
